import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Rating from "@material-ui/lab/Rating";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import Zoom from '@material-ui/core/Zoom';


const useStyles = makeStyles((theme) => ({
  PaperClass: {
    border: "solid white 1px",
    backgroundColor: "#2a2b3d",
    borderRadius: "15px",
    height: "150px",
    maxHeight: "150px",
    maxWidth: "80%",
    overflow: "clip",
    textAlign: "center",
    cursor: "pointer",
  },
  cardImage: {
    maxWidth: "70px",
    maxHeight: "70px",
    width: "auto",
    height: "auto",
    objectFit: "cover",
  },
}));

function MyCard(props) {
  const classes = useStyles();
  const prefersDarkMode = useMediaQuery("(prefers-color-scheme: dark)");
  return (
    <Zoom in={true} style={{ transitionDelay: '500ms' }} timeout={2000}>
    <Paper
      elevation={3}
      className={classes.PaperClass}
      style={{ backgroundColor: prefersDarkMode ? "#2a2b3d" : "whitesmoke" }}
      onClick={()=>{window.open(props.Link).focus();}}
    >
      <div style={{ minHeight: "75px", paddingTop: "5px" }}>
        <img src={props.logo} alt="Logo" className={classes.cardImage} />
      </div>
      <div style={{ textAlign: "center" }}>
        <h3 style={{ fontWeight: "lighter", margin: "5px" }}>{props.Name}</h3>
        <Rating
          name="half-rating-read"
          defaultValue={props.Score}
          precision={0.5}
          readOnly
          style={{
            color: prefersDarkMode ? "whitesmoke" : "#ffb400",
            fontSize: "1rem",
          }}
        />
      </div>
    </Paper>
    </Zoom>
  );
}

export default MyCard;
